import axios from "axios";

// Normalize the configured backend origin so the API base is ALWAYS exactly "<origin>/api"
// and never "/api/api". Tolerates values that already end in "/api", trailing slashes, or an
// empty value (empty => same-origin relative "/api", ideal for the same-origin proxy deploy).
const RAW = (process.env.REACT_APP_BACKEND_URL || "").trim();
let _origin = RAW.replace(/\/+$/, "").replace(/\/api$/i, "");

// Multi-domain safety: if the baked backend origin points at a DIFFERENT host than the page is
// actually served from (e.g. after the Super Admin switches the active Platform Domain, or a
// stale IP was baked into the build), fall back to a SAME-ORIGIN relative "/api". The reverse
// proxy serves the API on every Platform Domain, so this makes the app work on all of them and
// keeps auth cookies first-party. When the hosts match (preview / single-origin) nothing changes.
if (typeof window !== "undefined" && _origin) {
  try {
    if (new URL(_origin).host !== window.location.host) _origin = "";
  } catch { _origin = ""; }
}
export const BACKEND_ORIGIN = _origin;
export const API = `${BACKEND_ORIGIN}/api`;

export const http = axios.create({
  baseURL: API,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

let _activeTenant = null;
export function setActiveTenantHeader(tenantId) {
  _activeTenant = tenantId || null;
}
http.interceptors.request.use((config) => {
  if (_activeTenant) config.headers["X-Tenant-Id"] = _activeTenant;
  else delete config.headers["X-Tenant-Id"];
  return config;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// Generic resource helpers
export const listResource = async (resource, params = {}) => {
  const { data } = await http.get(`/${resource}`, { params });
  return data;
};
export const getResource = async (resource, id) => {
  const { data } = await http.get(`/${resource}/${id}`);
  return data;
};
export const createResource = async (resource, body, headers) => {
  const { data } = await http.post(`/${resource}`, body, headers ? { headers } : undefined);
  return data;
};
export const updateResource = async (resource, id, body) => {
  const { data } = await http.put(`/${resource}/${id}`, body);
  return data;
};
export const deleteResource = async (resource, id, params = {}) => {
  const { data } = await http.delete(`/${resource}/${id}`, { params });
  return data;
};
